export const dollarSignDecorator = (value: string | number, emptySymbol: string = '') => {
  if (value) {
    return `$${value}`;
  }

  return emptySymbol;
};
